export default __webpack_public_path__ + "locales/tr/EmptyTrashDialog.json?hash=7401e8c8f46f9fd399c18d6178d05ccb";